import React, { useCallback, useEffect, useMemo, useState } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { FormattedMessage, useIntl } from 'react-intl'
import { IMAGE_GEEKO_LTD } from '../../../../../../../../constants'
import { Iconfont } from '../../../../../../../components/icon/iconfont'
import BottomToTop from '../../../../../../../components/transitions/bottom-to-top'
import { BlackMask } from '../../../../../../../components/mask'
// import { withList } from '../../../../../../../components/list'
import { TrebleEmptyProducts, TrebleProducts } from '../../../../../../listing/components/list'
import { useDispatch, useSelector } from 'react-redux'
import { action_append_select_recommend_products, action_init_select_recommend_products } from '../../../../../../../../store/actions/pages/cart'
import { withScroll } from '../../../../../../support/pages/order-list-page/fragment/scroll-hook'

const PicksProducts = withScroll(props => {
    const {products, skip, innerRef, sensors} = props

    return (<React.Fragment>
        {/* {
            skip <=0 && products?.length < 0 &&
            <TrebleEmptyProducts count={21}/>
        } */}
        <div className={classes.ScrollBox} ref={innerRef}>
            {
                products?.length > 0 &&
                <TrebleProducts
                    products={products}
                    sensors={sensors}
                />
            }

            {
                props?.loadingDom
            }
        </div>
    </React.Fragment>
    )
})

const PicksModal = (props) => {
    useStyles(classes)
    const {products, onClose, request, skip, loading, finished, sensors} = props
    return (
        <div className={classes.PicksModalBox}>
            <div className={classes.PicksModalTitle}><FormattedMessage id={"picks_for_you"}></FormattedMessage></div>
            <Iconfont className={classes.PicksModalClose} onClick={onClose}>&#xe7c9;</Iconfont>

            <div className={classes.PicksModalProducts}>
                <PicksProducts
                    request={request}
                    products={products}
                    skip={skip}
                    loading={loading}
                    finished={finished}
                    style={{height: '100%'}}
                    sensors={sensors}
                    />
            </div>
        </div>
    )
}

const MiniProduct = (props) => {
    useStyles(classes)
    const {product} = props

    return (
        <div className={classes.MiniProductBox}>
            <img src={`${IMAGE_GEEKO_LTD}/small/${product?.pcMainImage}`} alt={product?.name} />
        </div>
    )
}


const SelectRecommend = (props) => {
    useStyles(classes)
    const {products, msg, productId} = props
    const intl = useIntl()
    const dispatch = useDispatch()
    const pageCart = useSelector(state => state.pageCart)
    const {selectRecommendProduct, selectRecommendFinished, selectRecommendLoading, selectRecommendSkip} = pageCart
    const [showPicks, setShowPicks] = useState(false)

    const sensors = {
        resourcepage_title: 'cart',
        resource_position: "1",
        resource_type: "4",
        resource_content: "cancel_item_rec"
    }

    useEffect(() => {
        if(window.GeekoSensors){
            window.GeekoSensors.Track("PitPositionExposure",sensors)
        }
    }, [])

    const showMsg = useMemo(() => {
        return msg ? msg: intl.formatMessage({id:'not_your_vibe_there_more', defaultMessage:'Not your vibe? There is more!'})
    }, [msg])

    const modalClose = () => {
        setShowPicks(false)
    }

    const fetchListData = async () => {
        if(!(selectRecommendFinished || selectRecommendLoading)){
            await dispatch(action_append_select_recommend_products(selectRecommendSkip, 21, productId))
        }
    }

    const openMask = useCallback(async () => {
        if(window.GeekoSensors){
            window.GeekoSensors.Track("PitPositionClick",sensors)
        }
        setShowPicks(true)
        await dispatch(action_init_select_recommend_products(0,21,productId))
    }, [productId])

    return (<React.Fragment>
        <div className={classes.SelectRecommendBox} onClick={() => openMask()}>
            <div className={classes.ProductsBox}>
                {
                    products?.length > 0 &&
                    products?.slice(0,3)?.map((item, index) => {
                        return <MiniProduct key={index} product={item}></MiniProduct>
                    })
                }
            </div>
            <div className={classes.Message} dangerouslySetInnerHTML={{__html: showMsg}}></div>
            <Iconfont className={classes.Icon}>&#xe78c;</Iconfont>
        </div>

        <BottomToTop in={showPicks} className={classes.BottomToTopBox}>
            <div>
                <PicksModal
                    products={selectRecommendProduct}
                    onClose={() => modalClose()}
                    request={() => fetchListData()}
                    loading={selectRecommendLoading}
                    finished={selectRecommendFinished}
                    skip={selectRecommendSkip}
                    sensors={sensors}
                    />
            </div>
        </BottomToTop>

        {showPicks && <BlackMask style={{zIndex: 9}} onClick={modalClose}/>}
    </React.Fragment>)
}

export default SelectRecommend
